/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelVitalSignsProfile.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/vital-signs-profile";

export class AutogenModelVitalSignsProfile<RowType extends ModelRow> extends Endpoint<RowType, RowVitalSignsProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowVitalSignsProfile extends ModelRow<RowVitalSignsProfileFields> {
	constructor(values?: Partial<RowVitalSignsProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowVitalSignsProfileFields {
	company_id: string;
	cost_per_mile: number;
	cost_per_mile_c: string;
	cost_per_mile_d: Date;
	cost_per_mile_n: number;
	cost_per_mile_r: number;
	day_of_week: string;
	dhp_goal_fri: number;
	dhp_goal_mon: number;
	dhp_goal_sat: number;
	dhp_goal_sun: number;
	dhp_goal_thu: number;
	dhp_goal_tue: number;
	dhp_goal_wed: number;
	driver_exit_group: string;
	end_date_value: string;
	exclude_rev_filter: string;
	exclude_weekend: string;
	gauge1: string;
	gauge2: string;
	gauge3: string;
	gauge4: string;
	gauge_refresh: string;
	id: string;
	mls_billed_flag: string;
	mls_dh_diff_flag: string;
	mls_dh_goal_flag: string;
	mls_dh_pct_flag: string;
	mls_empty_flag: string;
	mls_loaded_flag: string;
	nonrevenue_basis: string;
	num_days_in_week: number;
	ord_dspcomp_flag: string;
	ord_dspmade_flag: string;
	ord_entorders_flag: string;
	ord_numorders_flag: string;
	resp_codes: string;
	resp_level: number;
	rev_billed_flag: string;
	rev_delivered_flag: string;
	rev_filter_basis: string;
	rev_filter_values: string;
	rev_fuelsurch_flag: string;
	rev_goal_fri: number;
	rev_goal_fri_c: string;
	rev_goal_fri_d: Date;
	rev_goal_fri_n: number;
	rev_goal_fri_r: number;
	rev_goal_mon: number;
	rev_goal_mon_c: string;
	rev_goal_mon_d: Date;
	rev_goal_mon_n: number;
	rev_goal_mon_r: number;
	rev_goal_sat: number;
	rev_goal_sat_c: string;
	rev_goal_sat_d: Date;
	rev_goal_sat_n: number;
	rev_goal_sat_r: number;
	rev_goal_sun: number;
	rev_goal_sun_c: string;
	rev_goal_sun_d: Date;
	rev_goal_sun_n: number;
	rev_goal_sun_r: number;
	rev_goal_thu: number;
	rev_goal_thu_c: string;
	rev_goal_thu_d: Date;
	rev_goal_thu_n: number;
	rev_goal_thu_r: number;
	rev_goal_tue: number;
	rev_goal_tue_c: string;
	rev_goal_tue_d: Date;
	rev_goal_tue_n: number;
	rev_goal_tue_r: number;
	rev_goal_wed: number;
	rev_goal_wed_c: string;
	rev_goal_wed_d: Date;
	rev_goal_wed_n: number;
	rev_goal_wed_r: number;
	rev_gross_flag: string;
	rev_revenue_d_flag: string;
	rev_revenue_flag: string;
	rev_revenue_g_flag: string;
	rev_shipped_flag: string;
	rev_total_acc_flag: string;
	revenue_codes: string;
	revenue_date_basis: string;
	revenue_goal_basis: string;
	rpm_goal_fri: number;
	rpm_goal_fri_c: string;
	rpm_goal_fri_d: Date;
	rpm_goal_fri_n: number;
	rpm_goal_fri_r: number;
	rpm_goal_mon: number;
	rpm_goal_mon_c: string;
	rpm_goal_mon_d: Date;
	rpm_goal_mon_n: number;
	rpm_goal_mon_r: number;
	rpm_goal_sat: number;
	rpm_goal_sat_c: string;
	rpm_goal_sat_d: Date;
	rpm_goal_sat_n: number;
	rpm_goal_sat_r: number;
	rpm_goal_sun: number;
	rpm_goal_sun_c: string;
	rpm_goal_sun_d: Date;
	rpm_goal_sun_n: number;
	rpm_goal_sun_r: number;
	rpm_goal_thu: number;
	rpm_goal_thu_c: string;
	rpm_goal_thu_d: Date;
	rpm_goal_thu_n: number;
	rpm_goal_thu_r: number;
	rpm_goal_tue: number;
	rpm_goal_tue_c: string;
	rpm_goal_tue_d: Date;
	rpm_goal_tue_n: number;
	rpm_goal_tue_r: number;
	rpm_goal_wed: number;
	rpm_goal_wed_c: string;
	rpm_goal_wed_d: Date;
	rpm_goal_wed_n: number;
	rpm_goal_wed_r: number;
	rpt_goal_fri: number;
	rpt_goal_fri_c: string;
	rpt_goal_fri_d: Date;
	rpt_goal_fri_n: number;
	rpt_goal_fri_r: number;
	rpt_goal_mon: number;
	rpt_goal_mon_c: string;
	rpt_goal_mon_d: Date;
	rpt_goal_mon_n: number;
	rpt_goal_mon_r: number;
	rpt_goal_sat: number;
	rpt_goal_sat_c: string;
	rpt_goal_sat_d: Date;
	rpt_goal_sat_n: number;
	rpt_goal_sat_r: number;
	rpt_goal_sun: number;
	rpt_goal_sun_c: string;
	rpt_goal_sun_d: Date;
	rpt_goal_sun_n: number;
	rpt_goal_sun_r: number;
	rpt_goal_thu: number;
	rpt_goal_thu_c: string;
	rpt_goal_thu_d: Date;
	rpt_goal_thu_n: number;
	rpt_goal_thu_r: number;
	rpt_goal_tue: number;
	rpt_goal_tue_c: string;
	rpt_goal_tue_d: Date;
	rpt_goal_tue_n: number;
	rpt_goal_tue_r: number;
	rpt_goal_wed: number;
	rpt_goal_wed_c: string;
	rpt_goal_wed_d: Date;
	rpt_goal_wed_n: number;
	rpt_goal_wed_r: number;
	start_date_value: string;
	title: string;
	tl_idle_flag: string;
	tl_inservice_flag: string;
	tl_total_flag: string;
	tl_util_diff_flag: string;
	tl_util_flag: string;
	tl_util_goal_flag: string;
	tr_insrv_diff_flag: string;
	tr_insrv_goal_flag: string;
	tr_insrv_pct_flag: string;
	tr_open_flag: string;
	tr_total_flag: string;
	tr_working_flag: string;
	tractor_fleet: string;
	tractor_ins_goal: number;
	trailer_group: string;
	trailer_idle_days: number;
	trailer_util_goal: number;
	trpm_goal_fri: number;
	trpm_goal_fri_c: string;
	trpm_goal_fri_d: Date;
	trpm_goal_fri_n: number;
	trpm_goal_fri_r: number;
	trpm_goal_mon: number;
	trpm_goal_mon_c: string;
	trpm_goal_mon_d: Date;
	trpm_goal_mon_n: number;
	trpm_goal_mon_r: number;
	trpm_goal_sat: number;
	trpm_goal_sat_c: string;
	trpm_goal_sat_d: Date;
	trpm_goal_sat_n: number;
	trpm_goal_sat_r: number;
	trpm_goal_sun: number;
	trpm_goal_sun_c: string;
	trpm_goal_sun_d: Date;
	trpm_goal_sun_n: number;
	trpm_goal_sun_r: number;
	trpm_goal_thu: number;
	trpm_goal_thu_c: string;
	trpm_goal_thu_d: Date;
	trpm_goal_thu_n: number;
	trpm_goal_thu_r: number;
	trpm_goal_tue: number;
	trpm_goal_tue_c: string;
	trpm_goal_tue_d: Date;
	trpm_goal_tue_n: number;
	trpm_goal_tue_r: number;
	trpm_goal_wed: number;
	trpm_goal_wed_c: string;
	trpm_goal_wed_d: Date;
	trpm_goal_wed_n: number;
	trpm_goal_wed_r: number;
	user_list_default: string;
}

